import React from "react";
import { Grid, ListItem } from "@material-ui/core";
import { DownloadForOffline } from "@mui/icons-material";

const DocDownload = (props) => {
  const { data } = props;

  let { docName, apiPath, id, document } = data;
  return (<>
    {(document != null) && <ListItem container className="p0 pt6 pb20">
      <Grid className="w250 bold">{docName}</Grid>
      <Grid className="PDFDownload">
        <a
          className="doc-download-flex"
          href={`${apiPath}/employee/applicant/download?id=${id}&name=${document}`}
          target="_blank"
        >
          <Grid className="FileName">{docName}</Grid>
          <DownloadForOffline style={{ marginTop: "0px", color: "gray" }} />
        </a>
      </Grid>
    </ListItem>}
  </>
  )
};

export default DocDownload
